import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {dateInReqFormat, showTimeRange} from "../../services/Format/Date";
import "./style.scss";

const BookingDetailList = ({
  endTime,
  isOffice,
  region,
  serviceType,
  startTime,
  storeName,
  timeZone,
  country,
  bu,
}) => {
  const {t, i18n} = useTranslation();
  const isMobile = () => {
    return window.innerWidth <= 800;
  };
  return (
    <div className="flex-col flex-items-start w-max-content booking-detail-wrap">
      {isMobile() ? (
        ""
      ) : (
        <ul className="detailed-list">
          <li>
            <b>{t("country")}: </b>
            {country}
          </li>
          <li>
            <b>{t("region")}: </b>
            {region}
          </li>
        </ul>
      )}
      <ul className="detailed-list">
        <li>
          <b>{t("bu")}: </b>
          {bu}
        </li>
      </ul>
      <ul className="detailed-list">
        <li>
          <b>
            {isOffice ? t("office.label") : t("store.label")}
            {": "}
          </b>
          {storeName}
        </li>
        <li>
          <b>{t("date.label")}: </b>
          {dateInReqFormat(startTime, "MMMM DD [de] YYYY", i18n.language)}
        </li>
        <li>
          <b>{t("schedule")}: </b>
          {showTimeRange(startTime, endTime, timeZone)}
        </li>
      </ul>
      <ul className="detailed-list  longer-servicetype">
        <li>
          <b>
            {isOffice ? t("office.selectedSpace") : t("servicetype.label")}
            {": "}
          </b>
          {serviceType}
        </li>
      </ul>
    </div>
  );
};

BookingDetailList.propTypes = {
  endTime: PropTypes.string,
  isOffice: PropTypes.bool,
  location: PropTypes.string,
  serviceType: PropTypes.string,
  startTime: PropTypes.string,
  storeName: PropTypes.string,
  timeZone: PropTypes.string,
};

BookingDetailList.defaultProps = {
  endTime: "",
  isOffice: false,
  location: "",
  serviceType: "",
  startTime: "",
  storeName: "",
  timeZone: "",
};

export default BookingDetailList;
